import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import Forside from './pages/forside';
import Kvalitetssikring from './pages/kvalitetssikring';
import Kursus from './pages/kursus';
import KursusSider from './pages/kursusSider';
import Admin from './pages/admin';
import Login from './components/login';
import AdminEvents from './pages/adminEvents';
import AdminTilmeldinger from './pages/adminTilmeldinger';
import AdminReferences from './pages/adminReferences';
import ScrollToTop from './components/ScrollToTop';
import DriftOgVedligeholdelse from './pages/driftOgVedligeholdelse';
import Om from './pages/om';
import Kontakt from './pages/kontakt';
import Registrer from './components/registrer';
import PrivateRoute from './components/PrivateRoute';
import PhoneAndContact from './components/phoneAndContact';
import DynamiskSide from './pages/dynamiskside';
import References from './pages/references';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <PhoneAndContact />
        <Routes>
          <Route path="/" element={<Forside />} />
          <Route path="/kvalitetssikring" element={<Kvalitetssikring />} />
          <Route path="/kursus" element={<Kursus />} />
          <Route path="/kursus/:kursusId" element={<KursusSider />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/admin" 
            element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/admin/:kursusId" 
            element={
              <PrivateRoute>
                <AdminEvents />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/admin/:kursusId/tilmeldinger/:eventId?" 
            element={
              <PrivateRoute>
                <AdminTilmeldinger />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/admin/references" 
            element={
              <PrivateRoute>
                <AdminReferences />
              </PrivateRoute>
            } 
          />
          <Route path="/drift-og-vedligeholdelse" element={<DriftOgVedligeholdelse />} />
          <Route path="/om" element={<Om />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/referencer" element={<References />} />
          <Route path="/referencer/:caseId" element={<DynamiskSide />} />
          <Route 
            path="/registrer" 
            element={
              <PrivateRoute>
                <Registrer />
              </PrivateRoute>
            } 
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
